const activity = (ajaxinstance) => {
  const api = {}

  api.getKnockInit = id => ajaxinstance({
    method: 'POST',
    url: `/activity/daily/${id}/init`,
  })

  api.getKnockEvent = (id, eventId) => ajaxinstance({
    method: 'GET',
    url: `/activity/daily/${id}/event/${eventId}`,
  })

  api.receiveKnockEvent = (id, data) => ajaxinstance({
    method: 'POST',
    url: `/activity/daily/${id}/event/receive`,
    data,
  })

  api.saveKnockEvent = (id, data) => ajaxinstance({
    method: 'POST',
    url: `/activity/daily/${id}/event/save`,
    data,
  })

  api.gnInit = (id, data) => ajaxinstance({
    method: 'POST',
    url: `/activity/gn/${id}/init`,
    data,
  })

  api.getGnEvent = (id, eventId) => ajaxinstance({
    method: 'GET',
    url: `/activity/gn/${id}/event/${eventId}`,
  })

  api.receiveGnEvent = (id, data) => ajaxinstance({
    method: 'POST',
    url: `/activity/gn/${id}/event/receive`,
    data,
  })

  return api
}

export default activity
